export default "__VITE_ASSET__cec9c019__"